import initiativesService from "@/views/initiativeManager/service";
import router from '@/router'

const parseEnv = (key, fallback) => {
  const envValue = process.env[key];
  try {
    return envValue ? JSON.parse(envValue) : fallback;
  } catch (e) {
    console.error(`Erro ao processar a env ${key}:`, e);
    return fallback;
  }
};

const state = {
    error: false,
    initiaveLoading: false,
    initiativesList: [],
    totalInitiatives: 0,
    selectedInitiative: {},
    filters: {},
    // filters:
    search: "",
    selectedCreditor: null,
    metaCategory: null,
    sender: null,
    approved: null,
    showDeactivateds: null,
    //pagination:
    limit: null,
    order: null,
    page: null,
    // validations
    validUrls: parseEnv('VUE_APP_VALID_URLS', []),
    validLabels: parseEnv('VUE_APP_VALID_LABELS', {}),
};

const mutations = {
    setError(state, error) {
        state.error = error;
    },
    setInitiaveLoading(state, initiaveLoading) {
        state.initiaveLoading = initiaveLoading;
    },
    setInitiativeList(state, initiative_list) {
        state.initiativesList = initiative_list
    },
    setTotalInitiatives(state, total) {
        state.totalInitiatives = total
    },
    setSelectedInitiative(state, initiative) {
        state.selectedInitiative = initiative
    },
    clearSelectedInitiative(state) {
        state.selectedInitiative = {
            id: null,
            name: null,
            key: null,
            creditor_id: null,
            meta_category: null,
            description: null,
            header_type: null,
            header_text: null,
            message: null,
            footer: null,
            buttons: [],
        }
    },
    saveFilters(state, filters) {
        state.filters = filters;
    },
    // set filters:
    setSelectedCreditor(state, creditor_id) {
        state.selectedCreditor = creditor_id
    },
    setSearch(state, search) {
        state.search = search
    },
    setMetaCategory(state, category) {
        state.metaCategory = category
    },
    setSender(state, sender) {
        state.sender = sender
    },
    setApproved(state, approved) {
        state.approved = approved
    },
    setShowDeactivateds(state, showDeactivateds) {
        state.showDeactivateds = showDeactivateds
    },
    // set pagination
    setPage(state, page) {
        state.page = page
    },
    setLimit(state, limit) {
        state.limit = limit
    },
    setOrder(state, order) {
        state.order = order
    }
}

const actions = {
    getAllInitiatives({ commit, dispatch }, params = { limit: 9999 }) {
        commit('setError', false);
        commit('setInitiaveLoading', true);

        return initiativesService.getAllInitiatives(params).then((data) => {
            commit('setInitiativeList', data.objects)
            commit('setTotalInitiatives', data.num_results)
            dispatch("saveParams", params)
            return data;
        })
            .catch((err) => {
                commit('setError', true);
                throw err;
            })
            .finally(() => {
                commit('setInitiaveLoading', false);
            })
    },

    createInitiative({ state, commit }) {
        return initiativesService
        .createInitiative(state.selectedInitiative)
        .then((data) => {
            return data;
        })
        .catch((e) => {
            const message =
                e &&
                e.response &&
                e.response.data &&
                e.response.data.error
                    ? e.response.data.error
                    : "Ocorreu um erro ao criar a iniciativa.";
            commit("showSnackbar", message, { root: true });
        });
    },

    editInitiative({ state, commit }, initiative) {
        initiativesService.editInitiative(initiative).then((data) => {
            router.go()
        }).catch((error) => {
            const message =
                error &&
                error.response &&
                error.response.data &&
                error.response.data.error
                    ? error.response.data.error
                    : "Ocorreu um erro ao editar a iniciativa.";
            commit("showSnackbar", message, { root: true });
        })
    },
    saveApproval({ state, commit }, params) {
        initiativesService.saveApproval(params).then((data) => {
            const newInitiativesList = state.initiativesList.map(initiative => {
                if (initiative.id === data.id) return data; 
                return initiative;
            });

            commit('setInitiativeList', newInitiativesList)
        }).catch((e) => {
            const message =
                e &&
                e.response &&
                e.response.data &&
                e.response.data.error
                    ? e.response.data.error
                    : "Ocorreu um erro ao salvar a aprovação.";
            commit("showSnackbar", message, { root: true });
        })
    },
    saveParams({ commit }, params) {
        // filters
        if (params.selectedCreditor)
            commit("setSelectedCreditor", params.selectedCreditor);
        if (params.search) commit("setSearch", params.search);
        commit("setMetaCategory", params.meta_category);
        commit("setSender", params.phone_sender_id);
        commit("setApproved", params.approved);
        commit("setShowDeactivateds", params.show_deactivateds);
        // pagination
        commit("setPage", params.page);
        commit("setLimit", params.limit);
        commit("setOrder", params.order);
    },

    async activateOrDeactivateInitiative({ commit }, { initiatives }) {
        try {
            // Criar um array de Promises para cada chamada de `editInitiative`
            const promises = initiatives.map((initiative) => {
                const payload = {
                    id: initiative.id,
                    active: !initiative.active
                };

                return initiativesService.editInitiative(payload);
            });

            // Esperar todas as Promises serem resolvidas
            await Promise.all(promises);

            // Redirecionar após todas as atualizações
            router.go();
        } catch (error) {
            const message =
                error &&
                error.response &&
                error.response.data &&
                error.response.data.error
                    ? error.response.data.error
                    : "Ocorreu um erro ao ativar/desativar a iniciativa.";
            commit("showSnackbar", message, { root: true });
        }
    },

    async createInitiativeMedia({ commit }, params) {
        let resp = await initiativesService.createInitiativeMedia(params.info, params.type)
        return resp.files[0]
    },

    async uploadInitiativeMedia({ commit }, params) {
        await initiativesService.uploadInitiativeMedia(params.url, params.data)
    },

    async syncTemplate({ commit }, metaId) {
        try {
            await initiativesService.syncTemplate(metaId);
            commit("showSnackbar", "Template sincronizado com sucesso!", { root: true });
        } catch (error) {
            commit("showSnackbar", "Não foi possível sincronizar o template. Tente novamente em alguns instantes.", { root: true });
        }
    },

    // retorna true ou false caso a iniciativa possa ou não ser aprovada automaticamente
    async canAutoApproveInitiative({ state, commit }) {
        const initiative = state.selectedInitiative;
        if (!initiative) return false;

        let shouldApprove = false;
        let buttons = [];

        //prioriza os buttons que vem de meta_structure:
        if (initiative.meta_structure && initiative.meta_structure.components) {
            const metaButtons = initiative.meta_structure.components.find((c) => c.type === "BUTTONS");
            if (metaButtons) buttons = metaButtons.buttons || [];
        }

        //se não tiver, tenta pegar do initiative.buttons:
        if (!buttons.length && initiative.buttons) buttons = initiative.buttons || [];

        // se não tiver botões para verificar, aprova direto:
        if (!buttons.length) {
            shouldApprove = true;
        } else {
            shouldApprove = buttons.every(function(btn) {
                // se não for do tipo URL ou FLOW, não tem oq verificar, considera válido
                if (!["URL", "FLOW"].includes(btn.type)) return true;
                if (btn.type === "FLOW")
                    return btn.flow_action === "DATA_EXCHANGE";
                if (!btn.url) return false;

                // se tiver algum hash na URL, substitui por '{{1}}' para validar
                const url = btn.url.replace(/([?&]hash=)[^&]*/, '$1{{1}}');
                const validUrl = state.validUrls.indexOf(url) > -1;
                const labels = state.validLabels[url];
                const validLabel = labels && labels.indexOf(btn.text) > -1;

                return validUrl && validLabel;
            });
        }

        return shouldApprove;
    }
}

const getters = {
    error: (state) => state.error,
    initiaveLoading: (state) => state.initiaveLoading,
    initiativesList: (state) => state.initiativesList,
    selectedInitiative: (state) => state.selectedInitiative,
    selectedCreditor: (state) => state.selectedCreditor,
    metaCategory: (state) => state.metaCategory,
    sender: (state) => state.sender,
    search: (state) => state.search,
    approved: (state) => state.approved,
    showDeactivateds: (state) => state.showDeactivateds,
    totalInitiatives: (state) => state.totalInitiatives,
    validLabels: (state) => state.validLabels,
    validUrls: (state) => state.validUrls,
}

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true,
};